import { FC } from 'react';

import { GameV1 } from '@/api/games';
import { GameSizeConfig } from '@/components/GameItem';
import { GamesGrid, GamesGridStatic } from '@/components/GamesGrid';
import { PerChunk } from '@/components/GamesGrid/helpers';
import { useCommonStore } from '@/store';

import { GameItemSize } from '@/components/GameItem/styled';
import { GridOptions } from '@/components/GamesGrid/styled';

interface GamesGridBlockProps {
  category?: string;
  provider?: string;
  perChunkObj?: PerChunk;
  isSearchModal?: boolean;
}

export const gameSizesConfig: GameSizeConfig = {
  desktopL: GameItemSize.S,
  desktop: GameItemSize.S,
  tablet: GameItemSize.S,
  mobile: GameItemSize.S,
  mobileS: GameItemSize.S,
};

export const getGridOptions = (isMobileDevice: boolean) => ({
  columns: 4,
  columnsTablet: 4,
  columnsMobile: 4,
  columnsMobileS: 2,
  columnGap: isMobileDevice ? 16 : 12,
  rowGap: isMobileDevice ? 16 : 12,
});

export const GamesGridBlock: FC<GamesGridBlockProps> = ({
  category,
  perChunkObj,
  provider,
  isSearchModal,
}) => {
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  return (
    <GamesGrid
      perChunkObj={perChunkObj}
      category={category}
      provider={provider}
      gridOptions={getGridOptions(isMobileDevice)}
      plugGray={isMobileDevice}
      gameSizesConfig={gameSizesConfig}
      isSearchModal={isSearchModal}
    />
  );
};

interface GamesGridBlockStaticProps {
  games: GameV1[];
  loading: boolean;
  perChunkObj?: PerChunk;
  gridOptions?: GridOptions;
  plugGray?: boolean;
  totalCount?: number;
  isSearchModal?: boolean;
  onShowMoreButtonClick?: () => void;
}

export const GamesGridBlockStatic: FC<GamesGridBlockStaticProps> = ({
  games,
  perChunkObj,
  loading,
  gridOptions,
  plugGray,
  totalCount,
  isSearchModal,
  onShowMoreButtonClick,
}) => {
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  return (
    <GamesGridStatic
      perChunkObj={perChunkObj}
      games={games}
      loading={loading}
      gridOptions={gridOptions || getGridOptions(isMobileDevice)}
      plugGray={plugGray || isMobileDevice}
      gameSizesConfig={gameSizesConfig}
      totalCount={totalCount}
      isSearchModal={isSearchModal}
      onShowMoreButtonClick={onShowMoreButtonClick}
    />
  );
};
